import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import CSSZSickLeaveCertificateCreate from './CSSZSickLeaveCertificateCreate';
import { Size } from '../../../../Enums/Size.enum';
import { CSSZUser } from '../../Interfaces/CSSZ.interface';

interface Props extends BaseModalProps {
	onCreate?: (sickLeaveDocumentId?: string) => void | Promise<void>;
	user: CSSZUser;
	discourseDocumentId?: string;
}

const CSSZSickLeaveCertificateCreateModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.CSSZSickLeaveCertificateCreate.modalTitle'
			size={Size.LG}>
			<CSSZSickLeaveCertificateCreate
				onCreate={props.onCreate}
				user={props.user}
				discourseDocumentId={props.discourseDocumentId}
			/>
		</BaseModal>
	);
};

export default CSSZSickLeaveCertificateCreateModal;
